<template>
    <div>
        <error-badge
            v-if="error"
            :value="error"
            outlined
            ><v-btn icon @click="fetchData"><v-icon>refresh</v-icon></v-btn></error-badge>
        <!-- pass through scoped slots -->
        <template v-else>
            <v-data-table
                :expanded.sync="expandedModel"
                :headers="tableHeaders"

                :items="items"

                :loading="loading"

                :options.sync="options"
                :server-items-length="totalLength"

                :show-expand="showExpand"

                :single-expand="singleExpand"

                hide-default-footer
                v-bind="{loadingText,multiSort,itemKey}"
                @update:sort-desc="onUpdateSortBy"
                >
                <!-- pass through scoped slots -->
                <template v-for="(_,scopedSlotName) in $scopedSlots" v-slot:[scopedSlotName]="data"><slot :name="scopedSlotName" v-bind="data" ></slot></template>
                <!-- pass through unscoped slots -->
                <template v-for="(_,slotName) in $slots" v-slot:[slotName]><slot :name="slotName" ></slot></template>
                <!-- style from header type -->
                <template
                    v-for="(h,slot) in generatedItemSlots"
                    v-slot:[slot]="{ item }"
                    >
                    <component
                        v-bind:is="h.component"
                        v-if="h.component"
                        :header="h"
                        :item="item"
                        :name="h.value"
                        :value="item[h.value]"
                        ></component>
                    <!-- render by item type -->
                    <template v-else-if="h.type==='link'"><a :href="item[h.value]">{{item[h.value]}}</a></template>
                    <template v-else-if="h.type==='email'"><a :href="'mailto:'+item[h.value]">{{item[h.value]}}</a></template>
                    <template v-else-if="h.type==='phone'||h.type==='tel'"><a :href="'tel:'+item[h.value]">{{item[h.value]}}</a></template>
                    <template v-else-if="h.type==='date'">{{item[h.value]|date}}</template>
                    <template v-else-if="h.type==='datetime'||h.type==='time'">{{item[h.value]|dateTime}}</template>
                    <template v-else-if="h.type==='time'">{{item[h.value]|time}}</template>
                    <template v-else-if="h.type==='boolean'||h.type==='bool'">
                        <v-icon v-if="item[h.value]" color="success">check_circle</v-icon>
                        <v-icon v-else color="error">cancel</v-icon>
                    </template>
                    <template v-else-if="h.type.startsWith('currency')">{{item[h.value] ?h.type.substr(9)+' '+item[h.value].toFixed(2):'-'}}</template>
                    <template v-else-if="h.type.startsWith('prefix')">{{item[h.value] ?h.type.substr(7)+item[h.value]:'-'}}</template>
                    <template v-else-if="h.type.startsWith('suffix')">{{item[h.value] ?item[h.value]+h.type.substr(7):'-'}}</template>
                    <!-- fallback -->
                    <template v-else>{{item[h.value]}}</template>
                </template>


            </v-data-table>
            <!-- custom paginator -->
            <div class="d-flex justify-center align-content-center align-center">
                <v-pagination
                    v-if="result"
                    :disabled="loading"
                    :length="totalPages"
                    :total-visible="totalVisiblePages"
                    :value="currentPage"
                    @input="changePage"
                    ></v-pagination>
                <div>
                    <!--refresh button-->
                    <v-btn :loading="loading" icon @click="fetchData"><v-icon>refresh</v-icon></v-btn>
                </div>
            </div>
        </template>
    </div>
</template>
<script>
function isSimilar(a,b){
    return JSON.stringify(a)===JSON.stringify(b);
}

function normalizeSortingValue(sort){
    return sort?
            sort.map(e=>{
                if(typeof e === 'string'){
                    switch(e.charAt(0)){
                        case '^':
                            return [e.substr(1),'asc'];
                        case '-':
                            return [e.substr(1),'desc'];
                        default:
                            return [e];
                    }
                }
                return e;
            })
            : [];
}
export default {
    props: {
        action:{type:String,default:'',},
        method:{type:String,default:'get'},

        filters:{type:Object,default(){ return {};},},
        order:{type:Array,default(){}},//Sync

        //Page options
        pageSize:{type:Number},
        page:{type:Number,default:1},

        //DataTable options
        multiSort:{type:Boolean,default:true},
        headers:{type:Array},
        loadingText:{default:'Loading...'},

        totalVisiblePages:{type:Number,default:7},

        debounce:{type:Number,default:300},

        showExpand:{type:Boolean,default:false},
        singleExpand:{type:Boolean,default:false},
        expanded:{type:Array,default(){return [];}, },
        itemKey:{},
    },
    data() {
        return {
            query: new ResourceQuery(this.action,this.method),
            result:null,

            error:null,
            loading:false,

            promise:null,

            orderBy:this.order,

            options:{},

            debouncedFetch: _.debounce(()=>{this.fetchData();},this.debounce),
        };
    },
    mounted() {
        console.warn('scopedSlots',{scoped:this.$scopedSlots,slots:this.$slots});
        this.initQuery();
    },
    computed: {
        items(){ return (this.result && this.result.data) || []},
        totalLength(){return (this.result && this.result.total)||0;},
        totalPages(){return (this.result && this.result.last_page)||0;},
        expandedModel:{
            get(){return this.expanded},
            set(v){this.$emit('update:expanded',v);},
        },
        currentPage:{
            get(){
                return (this.result && this.result.current_page)||this.page;
            },
            set(v){
                this.$emit('update:page',v)
            }
        },
        itemsPerPage: {
            get() {
                return (this.result && this.result.per_page) || this.pageSize || 0;
            },
            set(v){
                this.$emit('update:pageSize',v);
            }
        },
        tableHeaders(){
            if(this.headers)
                return this.headers;
            //auto headers from data
            if(this.items && this.items.length>0) {
                return Object.keys(this.items[0]).map(field=>{
                    return {
                        text:field,
                        value:field,
                        //sortable: false,
                        //align: 'start',
                    };
                });
            }
            return [];
        },

        normalizedSort(){
            let sort = [];
            //if(this.order) sort = this.order;//<<???
            if(this.result && this.result.order_by){//<< server sorting, preferred
                sort = this.result.order_by;
            }
            return normalizeSortingValue(sort);
        },
        computedOptions(){
            let sortBy = [];
            let sortDesc = [];
            for(let sort of this.normalizedSort){
                let field = sort[0];
                let desc = sort.length>1 && sort[1]==='desc';
                sortBy.push(field);
                sortDesc.push(desc);
            }
            return  {
                itemsPerPage:this.itemsPerPage,
                page: this.currentPage,
                sortBy,
                sortDesc
            };
        },

        generatedItemSlots(){
            let slots = {};

            for(let h of this.headers){
                if(h.component || h.type){
                    let prop = 'item.'+h.value;
                    if(this.$scopedSlots[prop]===undefined){
                        //No item prop defined
                        slots[prop]=h;
                    }
                }
            }

            return slots;
        }
    },
    methods: {
        initQuery(){
            console.log('initquery')
            this.query.filters = this.filters;
            this.query.order_by = this.orderBy;
            this.query.pageSize = this.pageSize;
            this.query.page = this.page;
            this.fetchData();
        },
        fetchData(){
            //init paginator
            this.loading=true;
            this.promise = this.query.getResult()
                .then(r=>{
                    console.log('got result',r);
                    this.result = r;
                    this.updateTableOptions();
                })
                .catch(e=>{this.error=e;})
                .finally(()=>{this.loading=false;});
        },
        computeOptions(){
            let sortBy = [];
            let sortDesc = [];
            for(let sort of this.normalizedSort){
                let field = sort[0];
                let desc = sort.length>1 && sort[1]==='desc';
                sortBy.push(field);
                sortDesc.push(desc);
            }
            return  {
                itemsPerPage:this.itemsPerPage,
                page: this.currentPage,
                sortBy,
                sortDesc
            };
        },
        updateTableOptions(){
            //console.warn('>>>UPDATE TABLE OPTIONS')
            this.options.sortBy = this.computedOptions.sortBy;
            this.options.sortDesc = this.computedOptions.sortDesc;
            this.options.page = this.result.current_page;

            let normalizedOrder = normalizeSortingValue(this.order);
            if(!isSimilar(normalizedOrder,this.normalizedSort)){
                // Server changed sorting options, update prop
                this.$emit('update:order',this.normalizedSort);
            }
            //console.warn('>>>UPDATE TABLE OPTIONS',{options:this.options})
        },
        changePage(page){
            if(this.loading)
                return;
            console.warn('changePage',page)
            this.currentPage = page;
            this.query.page = page;
            this.fetchData();
        },
        onUpdateSortBy(){
            if(isSimilar(
                    [this.computedOptions.sortBy,this.computedOptions.sortDesc],
                    [this.options.sortBy,this.options.sortDesc],
                )){
                return;
            }
            if(!this.options.sortBy)return;
            console.warn('update sortby',JSON.stringify([
                [this.computedOptions.sortBy,this.computedOptions.sortDesc],
                [this.options.sortBy,this.options.sortDesc]],null,2))
            //Normalize sorting data
            let sort = [];
            for(let i in this.options.sortBy){
                let field = this.options.sortBy[i];
                let desc = this.options.sortDesc[i];
                sort.push([field,desc?'desc':'asc']);
            }

            //apply SORT
            this.orderBy = sort;
            this.query.order_by = sort;

            this.fetchData();
        },
        refresh(){
            this.fetchData();
        },
    },
    watch: {
        filters:{
            deep:true,
            handler(){
                console.log('FILTERS CHANGED')
                //Apply filters
                this.query.filters = this.filters;
                this.loading = true;
                this.debouncedFetch();
            },
        },
        debounce(){
            // Updates debounce value
            this.debouncedFetch && this.debouncedFetch.cancel();
            this.debouncedFetch = _.debounce(()=>{this.fetchData();},this.debounce);
        },
    },
    filters: {}
}
</script>
